import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  // Ads point at the bare domain, so the query string carries the whole ad
  // attribution (utm_*, fbclid, gclid). Forward it verbatim to the landing page.
  beforeLoad: ({ location }) => {
    throw redirect({
      href: `/vsl-v3${location.searchStr ?? ""}${location.hash ? `#${location.hash}` : ""}`,
    });
  },
});
